;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Collection = APP.module('Collection');
	const Model = APP.module('Model');
	
	Collection.MenuItems = Backbone.Collection.extend({
		model: Model.MenuItem,

		initialize: function(){

			
			this.setDefaults();

		},
		
		setDefaults: function(){
			var items = $.extend(true, [], this.defaults);

			if (this.default_items) {
				items = $.extend(true, [], CONFIG.OFF_SEASON ? this.off_season_items : this.default_items);
			}

			this.reset(items);

			return this;
		},

		//On state change actions (fired first)
		selectActiveState: function(state){

			this.setDefaults().each(function(item){
				item.set('is_active', false);
				item.set('is_active', item.isCurrentMenu(state));
			});

			APP.vent.trigger('show:menu');

			return this;
		},
		//Actions that fired after initial menu added
		show: function(){

			this.subMenuChangeOpenStatus();

			APP.vent.trigger('show:menu');

			return this;
		},

		subMenuChangeOpenStatus: function(){

			this.each(function(item){
				item.set('open_sub_menu_status', true);
			});

		},

		refresh: function(){
			APP.vent.trigger('show:menu');
			return this;
		},

		removeItemFromMenu: function(itemMethod){
			if(!itemMethod.length){
				return this;
			}

			this.each(function(item){
				item.hideItemSubMenuItem(itemMethod);
			});

			APP.vent.trigger('mobile_menu:removeItem', itemMethod);

			APP.vent.trigger('show:menu');

			return this;
		},

		setBreadcrumb: function(obj){

			this.each(function(item){
				item.set('breadcrumb', item.setBreadcrumb(obj));
			});

			return this;
		},

		replace: function(attr, replace_to){

			var replace_param = {
				param : attr,
				replace_to : replace_to
			};

			APP.vent.trigger('mobile_menu:replace', replace_param);

			this.each(function(item){
				item.replaceState(replace_param);
			});

			return this;
		},
		//Helpers

		setItemBreadcrumb: function(menu_item, key , obj, breadcrumb){

			if(menu_item.method_name == breadcrumb.method_name ){

				this.each(function(item){
					item.set('is_active', false);
					item.set('is_active', item.isCurrentMenu(state));
				});

			}

			return this;
		},
		getActiveItem(){
			let item = this.find('is_active', true);

			return item ? item.toJSON() : {};
		}
	});

}(window, APP, Backbone, Marionette, $, _));